<template>
  <button :class="disabled ? 'cart-button-disabled' : 'cart-button'" type="button" @click="submitCart">
    <span class="cart-button-spacer"></span>
    <span class="cart-button-text">
      <slot />
    </span>
    <span class="cart-button-icon">
      <icon-base width="22" height="22" :iconName="'Submit Cart'">
        <icon-bag />
      </icon-base>
    </span>
  </button>
</template>

<script>
import IconBase from '../IconBase.vue'
import IconBag from '../icons/IconBag.vue'

export default {
  name: 'CartButton',
  components: {
    IconBase,
    IconBag,
  },
  props: {
    disabled: { type: Boolean, default: false },
  },
  methods: {
    submitCart() {
      if (this.disabled) {
        return false
      }
      this.$emit('submit-cart')
    },
  },
}
</script>

<style lang="scss" scoped>
.cart-button {
  @include transition(background-color, transform);
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  width: 100%;
  padding: 11px 20px;
  background-color: $gold;
  border-radius: 22.5px;
  box-shadow: $box-shadow;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:focus {
    transform: translate(0, -2px);
    background-color: $royal;
  }
}

.cart-button-disabled {
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  width: 100%;
  padding: 11px 20px;
  background-color: $gray_2;
  border-radius: 22.5px;
  box-shadow: $box-shadow;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cart-button-spacer,
.cart-button-text,
.cart-button-icon {
  flex: 1 1 auto;
}

.cart-button-text {
  line-height: 1;
  margin: 0 15px;
}

.cart-button-icon {
  display: flex;
}
</style>
